export default __webpack_public_path__ + "static/media/1718 knife block A top.945abafe.png";